import { CardLoader } from '@enkla-gui'
import Tippy from '@tippyjs/react'
import React, { useState, useEffect } from 'react'

export default function Card({
	title,
	buttons,
	children,
	_class = '',
	icon,
	cols = 'col',
	loading = false,
	collapsed: collapsedProp = false // om null så är collapsiboy helt disabled
}) {
	const [collapsed, setCollapsed] = useState(collapsedProp)
	useEffect(() => {
		setCollapsed(collapsedProp);
	}, [collapsedProp]);

	const toggleCollapse = () => {
		//collapsed disabled
		if (collapsed === null) return
		setCollapsed(prev => !prev)
	}

	return (
		<div className={`component_Card ${cols}`}>
			<div className={`card ${_class}`}>
				{title && (
					<div
						className={`card-header ${collapsed ? 'card-header-collapsed' : ''}`}
						onClick={toggleCollapse}
					>
						<div className="card-header-text">
							{icon && <i className={`fa-fw ${icon}`} aria-hidden="true" />}
							<h2>{title}</h2>
						</div>
						<div className="card-header-buttons" style={{ display: 'flex', alignItems: 'center' }}>
							{buttons?.header?.map(button => {
								if (button.hidden || loading) return null
								if (React.isValidElement(button)) return button
								return (
									<Tippy content={button.text}>
										<div class="default">
											<a
												disabled={button.disabled}
												data-tip={button.text}
												href={button.link}
												class="btn btn-light btn-sm"
												aria-label={button.text}
												onClick={e => { e.stopPropagation(); button.callback?.() }}
											>
												<i className={button.icon} aria-hidden="true" />
											</a></div>
									</Tippy>
								)
							})}
							{/* Caret icon */}
							<Tippy content={collapsed ? 'Expandera' : 'Kollapsa'}>
								<i
									hidden={collapsed === null}
									className={`ml-2 fas fa-chevron-${collapsed ? 'down' : 'up'}`}
									style={{ transition: 'transform 0.2s', marginLeft: '5px', marginRight: '8px' }}
								/>
							</Tippy>
						</div>
					</div >
				)
				}
				{/* Collapse/expand section */}
				{
					!collapsed && (
						<div className="card-body">
							{!loading && children}
							{loading && <CardLoader />}
						</div>
					)
				}
				<div className="card-buttons">
					{buttons?.footer?.map(button => {
						if (button.hidden || loading) return null
						if (React.isValidElement(button)) return button
						return (
							<button
								disabled={button.disabled}
								className={`btn btn-${button.bg ? button.bg : 'primary text-light'}`}
								href={button.link}
								onClick={() => button.callback && button.callback()}
							>
								{button.text}
							</button>
						)
					})}
				</div>
			</div >
		</div >
	)
}
